import React from 'react';
import ForgotPassword from './containers/ForgotPassword';

function Index(props: any) {
    return (
        <ForgotPassword />
    );
}

export default Index;